import { Calendar, User } from 'lucide-react';
import { Treatment } from '../types';

interface TreatmentCardProps {
  treatment: Treatment;
  onClick: () => void;
}

const categoryLabels: Record<string, string> = {
  'pestanas': 'Pestañas',
  'lifting': 'Lifting',
  'cejas': 'Cejas',
  'micropigmentacion-cejas': 'Micropigmentación de Cejas',
  'micropigmentacion-labios': 'Micropigmentación de Labios',
  'micropigmentacion-ojos': 'Micropigmentación de Línea de Ojos',
  'manicura': 'Manicura',
  'pedicura': 'Pedicura',
  'tratamientos-faciales': 'Tratamientos Faciales',
  'corte-pelo':'Corte de Pelo',
  'tinte-cabello':'Tinte de Cabello'
};

export function TreatmentCard({ treatment, onClick }: TreatmentCardProps) {
  const photoAfter = treatment.photos.find(p => p.type === 'despues');
  
  return (
    <div 
      onClick={onClick}
      className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow cursor-pointer active:scale-[0.98] transition-transform"
    >
      {photoAfter && (
        <div className="h-32 bg-gray-100 overflow-hidden">
          <img 
            src={photoAfter.url} 
            alt="Resultado" 
            className="w-full h-full object-cover"
          />
        </div>
      )}
      
      <div className="p-4">
        <div className="flex items-center justify-between mb-2">
          <h4 className="font-semibold text-[#2d2d2d]">
            {categoryLabels[treatment.category]}
          </h4>
          {treatment.isDraft && (
            <span className="text-xs bg-yellow-100 text-yellow-700 px-2 py-1 rounded">
              Borrador
            </span>
          )}
        </div>
        
        <div className="flex items-center gap-4 text-sm text-gray-600">
          <div className="flex items-center gap-1">
            <Calendar className="w-4 h-4" />
            <span>{new Date(treatment.date).toLocaleDateString('es-ES')}</span>
          </div>
          <div className="flex items-center gap-1">
            <User className="w-4 h-4" />
            <span>{treatment.specialist}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
